module.exports = __webpack_public_path__ + "static/media/welcome screen22.8ede1718.jpg";